import request from '@/utils/request'

export function getExpressList(data) {
  return request({
    url: '/Api/brand.Order/expressList',
    method: 'post',
    data
  })
}
export function matchingEms(data) {
  return request({
    url: '/Api/KuaiDi/obtain_kd',
    method: 'post',
    data
  })
}

export function deliverGoods(data) {
  return request({
    url: 'Api/brand.Order/deliverGoods',
    method: 'post',
    data
  })
}

export function getPackageInfo(data) {
  return request({
    url: 'Api/brand.Order/getOrderPackageInfo',
    method: 'post',
    data
  })
}

